import { IIcd10CodeSearchConfiguration } from '@assess/browser/icd10-code-search';

import { environment } from '../../environments/environment';

export const icd10CodeSearch: IIcd10CodeSearchConfiguration = environment.icd10CodeSearch;
